export const sdf2DFunctions = ['circle', 'triangle', 'square', 'pentagon', 'hexagon', 'octogon', 'hexagram', 'rhombus', 'vesica'];
export function getShapeIndex(shape) {
  return sdf2DFunctions.indexOf(shape);
}